import React from 'react';
import "../../assets/css/scss/component/_videoPreview.scss"

export default function VideoPreview() {
  return (
    <div className="embed-responsive embed-responsive-21by9 h-100 video">
      <iframe title="test" className="embed-responsive-item" src="https://www.youtube-nocookie.com/embed/E160D9rEY0M?autoplay=0&showinfo=0&controls=0"></iframe>
      <div className="title">
        <h3 className="theme-white mb-0 bold">2019 Championship Base ball Highlight</h3>
      </div>
    </div>
  )
}


